import * as angular from "angular"
import { getDistinctValues, ICrop, sum } from "./omnia"
import { ICroppingGroupItem } from "./types"
import { getCropCssColor } from "@omnia/shared/fields"
import { PlanCroppingVm } from "./dashboard/table/vm/planCroppingVm"

export class CroppingGroupVm<T extends ICroppingGroupItem> {

    public headerText: string
    public visible: boolean = true

    public crop: ICrop

    public order: number;

    public groupInfoTemplate: string;

    public area: number

    public constructor(public readonly key: string, public cropping: T[]) {

        const distinct = getDistinctValues(cropping, c => c.cropping, c => c.CroppingId)

        this.area = Math.round(sum(distinct, c => c.Area) * 100) / 100

    }

    public copyTo<TGroup extends CroppingGroupVm<T>>(target: TGroup) {
        return angular.extend(target, this);
    }

    getSingleCropColor() {
        if (this.crop) {
            return getCropCssColor(this.crop);
        }
    }

    hasAllSelected(): boolean {
        return this.cropping.every(c => !!c.selected);
    }

    hasSomeSelected(): boolean {
        return this.cropping.some(c => c.selected);
    }

    selectAll(select: boolean) {
        this.cropping.forEach(c => c.selected = select && c.authorized);
    }

    getSelectedCropping(): T[] {
        return this.cropping.filter(c => c.selected);
    }

    hasRequirements(): boolean {
        return this.cropping.some(c => !!c.hasRequirements);
    }

}
